import {observable} from "mobx";
import {consoleApi, ConversionTimeEnum, WhiteboardEnum} from "../apiMiddleware";
import { message } from "antd";

export type QpsType = {teamId: number, maxQPS: number, checkDate: string, serviceType: string};
export type WhiteboardType = {
    totalDuration: number,
    writableDuration: number,
    readonlyDuration: number,
    timestamp: number,
    totalPeak: number,
    writablePeak: number,
    readonlyPeak: number,
};
export class DataStore {
    @observable
    public dynamic_qps_list: QpsType[] = [];
    @observable
    public static_qps_list: QpsType[] = [];
    @observable
    public team_duration: WhiteboardType[] = [];
    @observable
    public room_duration: WhiteboardType[] = [];
    @observable
    public writableDurationDayAdded: number = 0;
    @observable
    public readonlyDurationDayAdded: number = 0;
    @observable
    public writablePeakDayAdded: number = 0;
    @observable
    public readonlyPeakDayAdded: number = 0;
    @observable
    public roomWritableDurationDayAdded: number = 0;
    @observable
    public roomReadonlyDurationDayAdded: number = 0;
    @observable
    public roomWritablePeakDayAdded: number = 0;
    @observable
    public roomReadonlyPeakDayAdded: number = 0;
    @observable
    public dosageMonth: number = new Date().getMonth();

    // 获取 team 白板使用时长
    public async getTeamWhiteboardData(start: number, end: number): Promise<void> {
        try {
            const resp = await consoleApi.data.getWhiteboardData(start, end, WhiteboardEnum.team);
            if (resp.code === 200) {
                this.team_duration = resp.data.result;
                this.sumArrTeam(this.team_duration);
            }
        } catch (err) {
            message.error(err.message);
        }
    }


    // 获取静态 Qps
    public async getStaticConversionQps(start: number, end: number, type: ConversionTimeEnum): Promise<void> {
        try {
            const resp = await consoleApi.data.getConversionData(1, start, end, type);
            if (resp.code === 200) {
                this.static_qps_list = resp.data.QPSList;
            }
        } catch (err) {
            message.error(err.message);
        }
    }
    // 获取动态 Qps
    public async getDynamicConversionQps(start: number, end: number, type: ConversionTimeEnum): Promise<void> {
        try {
            const resp = await consoleApi.data.getConversionData(2, start, end, type);
            if (resp.code === 200) {
                this.dynamic_qps_list = resp.data.QPSList;
            }
        } catch (err) {
            message.error(err.message);
        }
    }
    private sumArrTeam(arr: WhiteboardType[]): void {
        let writableSum = 0;
        let readonlySum = 0;
        let writablePeakSum = 0;
        let readonlyPeakSum = 0;
        arr.forEach(ele => {
            writableSum += ele.writableDuration;
            readonlySum += ele.readonlyDuration;
            writablePeakSum += ele.writablePeak;
            readonlyPeakSum += ele.readonlyPeak;
        });
        this.writableDurationDayAdded = Math.round(writableSum);
        this.readonlyDurationDayAdded = Math.round(readonlySum);
        this.writablePeakDayAdded = Math.round(writablePeakSum);
        this.readonlyPeakDayAdded = Math.round(readonlyPeakSum);
    }
}
export const dataStore = new DataStore();



// WEBPACK FOOTER //
// ./src/models/DataStore.ts